export const ROUNDS = ['3 раунд', '4 раунд', '5 раунд', 'полуфинал', 'финал'];
